import { useState, useEffect } from "react";
import {
  Breadcrumb,
  Typography,
  Table,
  Row,
  Col,
  Card,
} from "antd";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import henceforthApi from "../utils/henceforthApi";
import { raceStat, raceStatus, userGender } from "../utils/CommonFunction";
import { getMapSnapshotUrl } from "../utils/googleMapSnapshot";


const participantsStatus = {
  JOINED: "Joined",
  READY_TO_GO: "Ready to go",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  INCOMPLETE: "Incomplete",
  LEFT: "Left",
};

const RaceView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState({});
  const [snapshotUrl, setSnapshotUrl] = useState("");

  const fetchRaceDetails = async () => {
    try {
      const res = await henceforthApi.Race.getById(id);
      const data = res?.data || {};
      setState(data);

      const hasValidCoordinates =
        data?.start_location?.coordinates?.length &&
        data?.end_location?.coordinates?.length;

      if (hasValidCoordinates) {

        const result = await getMapSnapshotUrl({
          startLocation: {
            lat: data.start_location.coordinates[1],
            lng: data.start_location.coordinates[0],
          },
          endLocation: {
            lat: data.end_location.coordinates[1],
            lng: data.end_location.coordinates[0],
          },
          googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
        });
        
        console.log("result", result)
        if (result?.snapshotUrl) {
          setSnapshotUrl(result.snapshotUrl);
        }

      }
    } catch (error) {
      console.error("Error fetching race:", error);
    }
  };

  useEffect(() => {
    fetchRaceDetails();
  }, [id]);

  const columns = [
    {
      title: "Sr. no.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, data) => (
        <div
          className="cursor-pointer"
          onClick={() => navigate(`/user/${data?.user_id?._id}/1/1?type=posts`)}
        >
          {data?.user_id?.full_name || "N/A"}
        </div>
      ),
    },
    {
      title: "Distance",
      dataIndex: "total_distance",
      key: "total_distance",
      render: (_, data) =>
        data?.total_distance
          ? `${(data.total_distance / 1000).toFixed(2)} Kms`
          : "N/A",
    },
    {
      title: "Rank",
      dataIndex: "position_rank",
      key: "position_rank",
      render: (_, data) => data?.position_rank || "N/A",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, data) => participantsStatus[data?.status] || "N/A",
    },
  ];

  return (
    <div className="px-6 py-4">
      <title>Race Details</title>

      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Card>
            <Breadcrumb separator=">">
              <Breadcrumb.Item className="cursor-pointer" onClick={()=>navigate(`/`)}>General</Breadcrumb.Item>
              <Breadcrumb.Item className="cursor-pointer" onClick={()=>navigate(`/race`)}>Race</Breadcrumb.Item>
              <Breadcrumb.Item>{state?.title}</Breadcrumb.Item>
            </Breadcrumb>

            <Typography.Title level={3}>Race Details</Typography.Title>

            <Row gutter={[20, 20]}>
              <Col span={12}>
                <ul className="list-unstyled">
                  <li>Name: {state?.title}</li>
                  <li>Race Status: {raceStat?.[state?.race_status] || "N/A"}</li>
                  <li>Race Type: {raceStatus?.[state?.race_type] || "N/A"}</li>
                  <li>
                    Distance:{" "}
                    {state?.total_distance
                      ? `${state.total_distance / 1000} kms`
                      : "N/A"}
                  </li>
                  <li>
                    Gender Preference:{" "}
                    {userGender?.[state?.gender_preference] || "N/A"}
                  </li>
                  <li>Starting point: {state?.start_location_name || "N/A"}</li>
                </ul>
              </Col>
              <Col span={12}>
                <ul className="list-unstyled">
                  <li>Total Participants: {state?.max_participants || "N/A"}</li>
                  <li>
                    Created On:{" "}
                    {state?.createdAt
                      ? dayjs(state.createdAt).format("DD MMM YYYY hh:mm a")
                      : "N/A"}
                  </li>
                  <li>
                    Start Time:{" "}
                    {state?.start_time
                      ? dayjs(state.start_time).format("DD MMM YYYY hh:mm a")
                      : "N/A"}
                  </li>
                  <li>
                    Scheduled Time:{" "}
                    {state?.scheduled_time
                      ? dayjs(state.scheduled_time).format("DD MMM YYYY hh:mm a")
                      : "N/A"}
                  </li>
                  <li>
                    End Time:{" "}
                    {state?.remaining_completion_time
                      ? dayjs(state.remaining_completion_time).format(
                        "DD MMM YYYY hh:mm a"
                      )
                      : "N/A"}
                  </li>
                  <li>Completion Point: {state?.end_location_name || "N/A"}</li>
                </ul>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row gutter={[20, 20]} className="my-4">
        {state?.destination_banner && (
          <Col xs={24} md={12} lg={12}>
            <div className="p-3 bg-white rounded shadow border h-100">
              <img
                src={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${state.destination_banner}`}
                alt="Destination Banner"
                className="w-100 rounded object-fit-cover"
                style={{ maxHeight: 300 }}
              />
              <p className="text-center mt-2 fw-medium small">Destination Banner</p>
            </div>
          </Col>
        )}

        {snapshotUrl && (
          <Col xs={24} md={12} lg={12}>
            <div className="p-3 bg-white rounded shadow border h-100">
              <img
                src={snapshotUrl}
                alt="Map Snapshot"
                className="w-100 h-70 rounded object-fit-cover"
                style={{ maxHeight: 500 }} // or 600, adjust as needed
              />

              <p className="text-center mt-2 fw-medium small">Map Snapshot</p>
            </div>
          </Col>
        )}
      </Row>

      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Card>
            <Typography.Title level={3}>Joined Participants</Typography.Title>
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={state?.participants || []}
              scroll={{ x: "100%" }}
              pagination={false}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RaceView;
